/* tslint:disable */
/* eslint-disable */
/**
 * Knowspread API v1
 *  This document describes API of education system Knowspread. This API is used by AngularJS web application. ##Api path Api lives on path `./api/v1/{resource}` relative to the root of the deployed application. ##Api versioning This api is versioned to allow further updates that would break backward compatibility. Current version is `v1` and it will be finalized when the App is deployed into production. In every response with status code `2xx`, `400`, `401` or `403` is returned `X-API-Version` header with current api version. This value is for checking correct api version used in Android or iOS application. ## Request and Response format Both response and request bodies are of type `application/json` if not noted otherwise.  ## Authentication Client accessing Knowspread application authenticates itself with a `POST` request against endpoint `./api/v1/users/login` through invitation link or with username and password. If the user authentication is successful an user unique identificator `uid` is returned together with an `access-token`, `client` - type of client, which allows to be authenticated on more devices, and information about access token expiration. (Please see corresponding API spec for concrete JSON format of request and response)  Each API call of given client is then authenticated using the returned `access-token`,`client` and `uid` which is passed to the server in header. Server returns `401 - Unauthorized` if the given token is expired or not valid. In case of invalid token, client can request a new one by authenticating against `./api/v1/users/login` again. AccessToken validity is automatically prolonged by using it.  ## Error States  The common [HTTP Response Status Codes](https://github.com/for-GET/know-your-http-well/blob/master/status-codes.md) are used for signaling error states.  Error status codes are specified in first endpoint in API spec - `./api/v1/`.  ##Success code `200` status code is returned on success (it does not matter if it is a Create,Read,Delete or Update operation) ## Common patterns in KnowSpread API  All REST based resources in this follow these rules:  * CREATE (`POST`) - Returns status code `201 (OK)` when the creation of entity is successful. and contains dictionary representing the created entity, * READ (`GET`) - Returns status code `200 (OK)` and dictionary or array of dictionaries representing the entity requested. Dictionary with the same keys is expected by the server when updating the entity. * UPDATE (`PUT`) - Returns status code `200 (OK)` and dictionary that represents state of the entity after modification. * DELETE (`DELETE`) - Returns status code `204 (OK)` upon successful deletion of entity.  ## Date formatting API accepts and returns dates in ISO_8601. For more info see: http://en.wikipedia.org/wiki/ISO_8601 ## Documentation tags * PAGEABLE - this marks this request as pageable. If you want to iterate over pages, set query `\'page\' (integer)` to number requested page. You can set query `\'paginates_per\' (integer)`, what sets records count on one page. This request returns count of total pages, current page and total records count in header. * JOB PROCESSING always - where job scheduled always * JOB PROCESSING sometimes - where job scheduled sometimes * JOB PROCESSING callbacks - where shceduled any jobs to support main action of endpoint e.g. assign content to all users in group etc. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { BillingOrderIndexResponseAmount } from './BillingOrderIndexResponseAmount';
import {
    BillingOrderIndexResponseAmountFromJSON,
    BillingOrderIndexResponseAmountFromJSONTyped,
    BillingOrderIndexResponseAmountToJSON,
} from './BillingOrderIndexResponseAmount';
import type { UserBasicInfo } from './UserBasicInfo';
import {
    UserBasicInfoFromJSON,
    UserBasicInfoFromJSONTyped,
    UserBasicInfoToJSON,
} from './UserBasicInfo';

/**
 * List of orders in a company space. Available filters are states, payment_methods, order_numbers, start_date, end_date and period. For states, payment_methods and order_numbers pass comma separated values. Sorted by default by order_number in descending order (newest first). E.g. 'states=pending, settled', 'payment_methods=gateway,bank_transfer', 'order_numbers=12345,67890', 'start_date=2026-01-01', 'end_date=2026-06-30'. Use period shorthand instead of start_date/end_date for common ranges 'period=year' (current calendar year), 'period=month' (current calendar month). Existing old orders (till 2026) could use payment method 'braintree' which are automatically included in filter 'gateway'. Orders can be paginated via page and per_page params.
 * @export
 * @interface BillingOrderIndexResponse
 */
export interface BillingOrderIndexResponse {
    /**
     * 
     * @type {number}
     * @memberof BillingOrderIndexResponse
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof BillingOrderIndexResponse
     */
    order_number: string;
    /**
     * 
     * @type {string}
     * @memberof BillingOrderIndexResponse
     */
    state: BillingOrderIndexResponseStateEnum;
    /**
     * 
     * @type {string}
     * @memberof BillingOrderIndexResponse
     */
    payment_method: BillingOrderIndexResponsePaymentMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof BillingOrderIndexResponse
     */
    order_document_url: string | null;
    /**
     * 
     * @type {Date}
     * @memberof BillingOrderIndexResponse
     */
    created_at: Date;
    /**
     * 
     * @type {BillingOrderIndexResponseAmount}
     * @memberof BillingOrderIndexResponse
     */
    amount: BillingOrderIndexResponseAmount;
    /**
     * 
     * @type {BillingOrderIndexResponseAmount}
     * @memberof BillingOrderIndexResponse
     */
    amount_with_vat: BillingOrderIndexResponseAmount;
    /**
     * 
     * @type {string}
     * @memberof BillingOrderIndexResponse
     */
    public_html_url: string | null;
    /**
     * 
     * @type {string}
     * @memberof BillingOrderIndexResponse
     */
    purpose: BillingOrderIndexResponsePurposeEnum;
    /**
     * 
     * @type {string}
     * @memberof BillingOrderIndexResponse
     */
    content_name: string | null;
    /**
     * 
     * @type {UserBasicInfo}
     * @memberof BillingOrderIndexResponse
     */
    order_creator?: UserBasicInfo;
}


/**
 * @export
 */
export const BillingOrderIndexResponseStateEnum = {
    Unsubmitted: 'unsubmitted',
    Pending: 'pending',
    Settled: 'settled',
    Failed: 'failed'
} as const;
export type BillingOrderIndexResponseStateEnum = typeof BillingOrderIndexResponseStateEnum[keyof typeof BillingOrderIndexResponseStateEnum];

/**
 * @export
 */
export const BillingOrderIndexResponsePaymentMethodEnum = {
    Gateway: 'gateway',
    BankTransfer: 'bank_transfer',
    Cash: 'cash',
    Code: 'code'
} as const;
export type BillingOrderIndexResponsePaymentMethodEnum = typeof BillingOrderIndexResponsePaymentMethodEnum[keyof typeof BillingOrderIndexResponsePaymentMethodEnum];

/**
 * @export
 */
export const BillingOrderIndexResponsePurposeEnum = {
    Content: 'content',
    Subscription: 'subscription',
    LearningEvent: 'learning_event'
} as const;
export type BillingOrderIndexResponsePurposeEnum = typeof BillingOrderIndexResponsePurposeEnum[keyof typeof BillingOrderIndexResponsePurposeEnum];


/**
 * Check if a given object implements the BillingOrderIndexResponse interface.
 */
export function instanceOfBillingOrderIndexResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "order_number" in value;
    isInstance = isInstance && "state" in value;
    isInstance = isInstance && "payment_method" in value;
    isInstance = isInstance && "order_document_url" in value;
    isInstance = isInstance && "created_at" in value;
    isInstance = isInstance && "amount" in value;
    isInstance = isInstance && "amount_with_vat" in value;
    isInstance = isInstance && "public_html_url" in value;
    isInstance = isInstance && "purpose" in value;
    isInstance = isInstance && "content_name" in value;

    return isInstance;
}

export function BillingOrderIndexResponseFromJSON(json: any): BillingOrderIndexResponse {
    return BillingOrderIndexResponseFromJSONTyped(json, false);
}

export function BillingOrderIndexResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BillingOrderIndexResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'order_number': json['order_number'],
        'state': json['state'],
        'payment_method': json['payment_method'],
        'order_document_url': json['order_document_url'],
        'created_at': (new Date(json['created_at'])),
        'amount': BillingOrderIndexResponseAmountFromJSON(json['amount']),
        'amount_with_vat': BillingOrderIndexResponseAmountFromJSON(json['amount_with_vat']),
        'public_html_url': json['public_html_url'],
        'purpose': json['purpose'],
        'content_name': json['content_name'],
        'order_creator': !exists(json, 'order_creator') ? undefined : UserBasicInfoFromJSON(json['order_creator']),
    };
}

export function BillingOrderIndexResponseToJSON(value?: BillingOrderIndexResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'order_number': value.order_number,
        'state': value.state,
        'payment_method': value.payment_method,
        'order_document_url': value.order_document_url,
        'created_at': (value.created_at.toISOString()),
        'amount': BillingOrderIndexResponseAmountToJSON(value.amount),
        'amount_with_vat': BillingOrderIndexResponseAmountToJSON(value.amount_with_vat),
        'public_html_url': value.public_html_url,
        'purpose': value.purpose,
        'content_name': value.content_name,
        'order_creator': UserBasicInfoToJSON(value.order_creator),
    };
}

